import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import languageList from '../../assets/language/language.json'
import useHttp from "../../axios/useHttp";
import endpoints from "../../axios/endPoints";
import useWindowSize from "../../Hooks/useWindowSize";
import { 
  Container,
  LoginSectionWrapper,
  ChartTitle,
  Label,
  TopLabel,
  BottomText,
  HistoricalContainer,
  LeftTab,
  HistoricalLabel,
  RightTab,
  Underlying,
  Circle,
  SelectField,
  Year,
  ChartContainer,
  VerticalText,
  ChartWrapper,
  OptionField,
  Divider,
  CustomOverlay,
  EmptyDataContainer
} from "./Login.style";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const LoginSection = () => {

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const windowSize = useWindowSize();
  const { get } = useHttp();
  const [productName, setProductName] = useState(undefined)
  const [languages, setLanguage] = useState(null)
  const [shareClass, setShareClass] = useState([])
  const language = searchParams.get("lang") || 'en';
  const shareClassParam = searchParams.get("share_class") || null;
  const yearParam = searchParams.get("year") || null;
  const [yearList, setYearList] = useState([])
  const [selectedYear, setSelectedYear] = useState(undefined)
  const [labels, setLabelList] = useState([])
  const [dataSet, setDataSet] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [fundStartDate, setFundStartDate] = useState(200)
  useEffect(() => {
      
      // getShareClass()
      // generateArrayOfYears()
  }, [])

  const generateArrayOfYears = () => {
    const max = new Date().getFullYear()
    const min = max - 9
    const years = []
    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    if(!yearParam){
      setSelectedYear(years[1])
    }
    setYearList(years)
  }

  const getShareClass = async () => {

      setLoading(true)
      try {
          const response = await get({endpoint: endpoints.getShareClass});
          if(response && !shareClassParam){
            setProductName(response[0]?.share_class_isin)
          }
          setShareClass(response)
          setLoading(false)
      } catch (err) {
        setLoading(false)
      }
  }

  useEffect(() => {
    if(languageList[language]){
      setLanguage(languageList[language])
    } else {
      setLanguage(languageList['en'])
    }

  }, [language])

  useEffect(() => {
      if(shareClassParam){
        setProductName(shareClassParam)
      }
      if(yearParam){
        setSelectedYear(yearParam)
      }
  }, [shareClassParam, yearParam])

  const handleChange = (event) => {
    const { value } = event.target
    setProductName(value)
  }

  const handleYearChange = (event) => {
    const { value } = event.target
    setSelectedYear(value)
  }

  useEffect(() => {
    if(selectedYear && productName){
      fetchMonthlyData()
    }
  }, [selectedYear, productName])

  const fetchMonthlyData = () => {
    getMonthlyData()
  }

  const getMonthlyData = async () => {
    setLoading(true)
    try {
        const response = await get({endpoint: `${endpoints.shareNavPrice}/${productName}/${selectedYear}`});
        const labelArray = []
        const dataArray = []
        if(response && response?.data){
          const reversedData = response?.data
          reversedData?.map(singleRow =>{
            labelArray.push(singleRow?.Month)
            dataArray.push(singleRow?.NAV_PRICE_WITH_DIVIDEND_REINVESTED?.toFixed(2))
          })
          setLabelList(labelArray)
          setDataSet(dataArray)
          setLoading(false)
        }
        if(response?.fund_start_date){
          setFundStartDate(response?.fund_start_date)
        } else {
          setFundStartDate(null)
        }
    } catch (err) {
      setLoading(false)
    }
}



const data = {
  labels,
  datasets: [
    {
      label: '',
      data: dataSet,
      backgroundColor: '#0096FF',
      barThickness: windowSize?.width < 600 ? 10 : 20,
      barPercentage: 1,
    },
  ]
};

const getOptions = (yList) => {
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        display: false
      },
      title: {
        display: false,
        text: '',
      },
      tooltip: {
        displayColors:false,
        callbacks: {
          title: (xDatapoint) => {return false},
          label: (yDatapoint) => {return yDatapoint.raw + (yList ? ' ' : '%')},
        }
      }
      
    },
    scales: {
      x: {
        display: true,
        grid: {
          display: false
        }
      },
      y: {
        border:{
          dash: [3, 3], 
          display: false },
        ticks: {
          beginAtZero: true,
          callback: function(value) {
            return `${value}  ${yList  ? ' ' : '%'} `;
          }
        },
        beginAtZero: true,
      }
    },
    onClick: (evt, element) => {
      if(element.length > 0) {
          console.log(evt, element)
      }}
  };

  return options
}

const getFormattcedFund = ()=> {
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May","Jun","Jul", "Augt", "Sep", "Oct", "Nov","Dec"];
  if(fundStartDate){
    const d = new Date(fundStartDate);
    return monthNames[d?.getMonth()]+', '+d?.getFullYear()
  } else {
    return null
  }
 
}

  return (
    <Container height={windowSize?.width < 1200 ? windowSize?.height : null}>
      <BottomText>
        NAV Price chart has been removed. {/*{languages?.policy}*/}
      </BottomText>
    </Container>
  );
};

export default LoginSection;
